<spr-page-with-title
	[title]="controller.title$ | async"
	class="h-full"
	styleClass="flex items-stretch flex-col"
>
	<p-scrollPanel styleClass="absolute top-0 right-0 left-0 bottom-0">
		<div class="px-3 md:px-36 space-y-6 py-6">
			<div class="flex flex-col space-y-6 xl:flex-row xl:space-x-6 xl:space-y-0">
				<spr-coach-profile-information
					[coach]="controller.coach$ | async"
				></spr-coach-profile-information>
				<spr-coach-profile-sectors
					*ngIf="controller.sectors$ | async | nullIfEmpty as sectors"
					[sectors]="sectors"
				></spr-coach-profile-sectors>
			</div>
			<div class="flex flex-col space-y-6">
				<spr-coach-profile-biography
					*ngIf="controller.biography$ | async as biography"
					[biography]="biography"
				></spr-coach-profile-biography>
				<spr-coach-profile-diplomas
					*ngIf="controller.diplomas$ | async | nullIfEmpty as diplomas"
					[diplomas]="diplomas"
				></spr-coach-profile-diplomas>
				<spr-coach-profile-certificates
					*ngIf="controller.certificates$ | async | nullIfEmpty as certificates"
					[certificates]="certificates"
				></spr-coach-profile-certificates>
			</div>
		</div>
	</p-scrollPanel>
</spr-page-with-title>
